// Semver of the analyzer ruleset. Bump on any change to detector logic or
// thresholds so a result's provenance is auditable (recorded in meta).
export const RULESET_VERSION = '1.0.0';
